export default "__VITE_ASSET__BOPDQipT__"